module.exports = global["jQuery"] = require("-!/builds/softplan/infraestrutura-e-obras/obrasgov/projetos/smo/mapa/frontend/obrasgov-map-frontend/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 7
// module chunks = 0